import { useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'

import ProfessionalSlider from './components//imageSlider'
import Profile from '../asset/chisono/NordinProfile.png'
import Loghi from '../asset/chisono/Loghi.png'
import image1 from '../asset/chisono/1.jpg'
import image2 from '../asset/chisono/2.jpg'
import image3 from '../asset/chisono/3.jpg'
import image4 from '../asset/chisono/4.jpg'
import image5 from '../asset/chisono/5.jpg'
import image6 from '../asset/chisono/6.jpg'
import image8 from '../asset/chisono/8.jpg'
import image9 from '../asset/chisono/9.jpg'
import image10 from '../asset/chisono/10.jpg'
import image11 from '../asset/chisono/11.jpg'
import image12 from '../asset/chisono/12.jpg'
import image13 from '../asset/chisono/13.jpg'
import image14 from '../asset/chisono/14.jpg'

gsap.registerPlugin(ScrollTrigger)

export default function ChiSono () {
    const container = useRef()
    const imageUrls = [
        image1,image2,image3,image4,image5,image6,image8,image9,image10,image11,image12,image13,image14
    ];

    useGSAP(() => {
    gsap.from('.intro-box', {
        scrollTrigger: {
            trigger: '.intro-box',
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        y: 80,
        duration: 1.4,
        ease: 'expo.out',
    });

    gsap.from('.loghi-img', {
        scrollTrigger: {
            trigger: '.loghi-img',
            start: 'top 90%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        scale: 0.85,
        duration: 1.3,
        ease: 'power1.out',
    });

    gsap.from('.profile-img', {
        scrollTrigger: {
            trigger: '.profile-img',
            start: 'top 90%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        x: 100,
        duration: 1.3,
        ease: 'power2.out',
    });

    gsap.from('.slider', {
        scrollTrigger: {
            trigger: '.slider',
            start: 'top 90%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        x: -100,
        duration: 1.3,
        ease: 'expo.out',
    });

    gsap.from('.qualcosa-box', {
        scrollTrigger: {
            trigger: '.qualcosa-box',
            start: 'top 85%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        y: 80,
        duration: 1.5,
        ease: 'expo.out',
    });
    

    gsap.from('.competenze-box', {
        scrollTrigger: {
            trigger: '.competenze-box',
            start: 'top 85%',
            toggleActions: 'play none none none',
        },
        opacity: 0,
        scale: 0.95,
        y: 100,
        duration: 1.2,
        ease: 'power3.out',
    });

    gsap.from('.icon-set img', {
        scrollTrigger: {
            trigger: '.icon-set',
            start: 'top 90%',
            toggleActions: 'play none none none',
            once: true,
        },
        opacity: 0,
        y: 30,
        stagger: 0.15,
        duration: 0.9,
        ease: 'power1.out',
    });
    }, { scope: container });


    return (
        <section name="chi-sono" ref={container}>
            <div className="flex lg:flex-row flex-col lg:pr-8 lg:pl-8 pt-4 lg:gap-4">
                <div className='gap-8 lg:p-0 p-5 flex flex-col'>
                    <div className='intro-box bg-[#5b90ab70] justify-center text-center lg:mt-14 w-full rounded-3xl shadow-2xl pb-4'>
                        <h1 className='text-white text-4xl font-semibold pt-5'>Chi Sono ?</h1>
                        <p className='text-white font-thin text-2xl p-4'>
                            Dietro ogni intervento c’è la cura di chi lavora con passione. Nordin non è solo un tecnico: è la persona su cui puoi contare quando qualcosa si rompe, quando qualcosa va fatto bene. Precisione, esperienza, competenza e un approccio umano fanno la differenza. E la differenza… si vede.
                        </p>
                    </div>
                    <div className='loghi-img bg-[#5b90ab70] h-full flex justify-center lg:p-2 p-5 rounded-3xl items-center shadow-2xl'>
                        <img src={Loghi} className='lg:h-50 h-18' />
                    </div>
                </div>
                <img src={Profile} className='profile-img -scale-x-100 lg:p-0 pl-4' />
            </div>
            <div className='lg:p-8 p-6 competenze-box'>
                <div className='bg-[#5b90ab70] rounded-3xl px-8 py-6 shadow-3xl'>
                    <h1 className='text-white text-3xl font-semibold text-center pt-2 pb-6 tracking-wide'>
                        Certificazioni
                    </h1>

                    <div className='competenze space-y-6 divide-y divide-[#7fb4cc]/30'>
                        <div className='p-4 text-white hover:bg-[#7fb4cc]/20 transition-all duration-300 rounded-xl'>
                            <h2 className='text-xl font-bold mb-2 flex items-center'>
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Patentino F-GAS
                            </h2>
                            <p className='text-[#e6f2f8] leading-relaxed'>
                                Certificazione aziendale e personale per installazione di condizionatori e operazioni su pompe di calore.
                            </p>
                        </div>

                        <div className='p-4 text-white hover:bg-[#7fb4cc]/20 transition-all duration-300 rounded-xl pt-6'>
                            <h2 className='text-xl font-bold mb-2 flex items-center'>
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Corso FER – Energie Rinnovabili
                            </h2>
                            <p className='text-[#e6f2f8] leading-relaxed'>
                                Formazione per operare su biomassa, caldaie a legna/pellet e canne fumarie, in conformità alle normative FER.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex lg:flex-row flex-col lg:pl-8 lg:pr-8 lg:pb-8 p-5 gap-8'>
                <div className='slider'>
                    <ProfessionalSlider images={imageUrls}></ProfessionalSlider>
                </div>
                <div className='qualcosa-box bg-[#5b90ab70] w-full rounded-3xl shadow-3xl text-center'>
                    <h1 className='text-white text-4xl pt-5 font-semibold'>Qualcosa sui nostri lavori</h1>
                    <p className='text-white font-thin text-2xl p-4 pt-10'>
                        Ogni intervento che realizziamo è il risultato di esperienza, passione e cura per i dettagli. Non ci limitiamo a “fare il lavoro”: ascoltiamo, analizziamo e proponiamo soluzioni su misura, progettate per durare nel tempo e rispondere davvero alle esigenze dei nostri clienti.
                        Che si tratti di installare un impianto di climatizzazione, effettuare la manutenzione di una stufa a pellet, ristrutturare un bagno o sistemare un impianto idrico, affrontiamo ogni progetto con lo stesso impegno e la stessa precisione. Per noi, la qualità non è un optional: è lo standard.
                    </p>
                    <div className="icon-set hidden md:flex flex-row justify-center gap-4 pt-10">
                        <img width="100" height="100" src="https://img.icons8.com/sf-black-filled/64/ffffff/air-conditioner.png" alt="air-conditioner" />
                        <img width="100" height="100" src="https://img.icons8.com/ios-filled/50/ffffff/water-heater.png" alt="water-heater" />
                        <img width="100" height="100" src="https://img.icons8.com/ios-filled/50/ffffff/water-pipe.png" alt="water-pipe" />
                        <img width="100" height="100" src="https://img.icons8.com/ios-filled/50/ffffff/toilet-bowl.png" alt="toilet-bowl" />
                        <img width="100" height="100" src="https://img.icons8.com/pastel-glyph/64/ffffff/chimney--v1.png" alt="chimney--v1" />
                        <img width="100" height="100" src="https://img.icons8.com/ios-filled/50/ffffff/cooker.png" alt="cooker" />
                    </div>
                </div>
            </div>
        </section>
    )
}
